import { randomString } from './string-utils';

export function generateNoteGlobalId() {
  return randomString(16);
}
